"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var React = _interopRequireWildcard(require("react"));
var _common = require("../../types/common");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _InContextAlert = require("../InContextAlert");
var _BannerModule = _interopRequireDefault(require("./Banner.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Banner = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    semantic,
    leftIconType = 'solid',
    alignment = 'top',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_InContextAlert.InContextAlert, _extends({}, props, {
    leftIconType: leftIconType,
    semantic: semantic,
    ref: ref,
    classNames: {
      ...classNames,
      wrapper: (0, _classify.default)(_BannerModule.default.bannerContainer, {
        [_BannerModule.default.neutral]: semantic === _common.ALERT_SEMANTIC.neutral,
        [_BannerModule.default.success]: semantic === _common.ALERT_SEMANTIC.success,
        [_BannerModule.default.information]: semantic === _common.ALERT_SEMANTIC.information,
        [_BannerModule.default.warning]: semantic === _common.ALERT_SEMANTIC.warning,
        [_BannerModule.default.danger]: semantic === _common.ALERT_SEMANTIC.danger,
        [_BannerModule.default.topAligned]: alignment === 'top',
        [_BannerModule.default.bottomAligned]: alignment === 'bottom'
      }, classNames?.wrapper),
      alertText: (0, _classify.default)(classNames?.alertText),
      actionContainer: (0, _classify.default)(_BannerModule.default.alertContainer, classNames?.actionContainer)
    }
  })));
});
exports.Banner = Banner;